import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import Message from 'components/atoms/Message';
import { RootState } from 'types';
import { ActionsType } from 'types/system';
import { renderError, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface EditTransitsModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    actions: ActionsType | undefined;
}

interface EditTransitsModelState {
    errors: object;
    data: any | null;
    tagTypes: { name: string; value: string }[];
}

class EditTransitsModel extends Component<EditTransitsModelProps, EditTransitsModelState> {
    constructor(props: EditTransitsModelProps) {
        super(props);
        this.state = {
            data: null,
            errors: {},
            tagTypes: [{ name: 'Abort', value: 'Abort' }],
        };
    }

    handleChange = (name: string, value: unknown) => {
        const { data, errors } = this.state;
        setKey(data, name, value);
        setKey(errors, name, null);
        this.setState({ data, errors });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.props.actions?.onCancel();
    };
    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Edit transits')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div>{translate('Update type tag')}</div>
                    <FormGroup comments={renderError(this.state.errors?.['typeTag'])} required={false}>
                        <Label className="text-gray-300">{translate('Type tag')}</Label>
                        <DropList  capitalize
                            name="typeTag"
                            id="typeTag"
                            value="Abort"
                            options={this.state.tagTypes.map((x) => {
                                return { value: x.name, label: x.name };
                            })}
                            onChange={this.handleChange}
                        ></DropList>
                    </FormGroup>

                    <Message type="error">{translate('Message text')}</Message>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    language: state.user.user.language,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EditTransitsModel);
